import Assistant from "../assistant/Assistant";
import ExitButton from "../buttons/ExitButton";
import SendFormButton from "../buttons/SendFormButton";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { BaseModalForm } from "./modalStyle";
import { useDispatch, useSelector } from "react-redux";
import {
  sendContribution,
  updateContribution,
} from "../kanban/contributionsActions";
import { loadProject } from "../project/one-project/projectAction";
import { FunctionalModal } from "./FunctionalModal";

const ContributionModal = ({ setIsOpen, task }) => {
  const [isUpdateAction, setIsUpdateAction] = useState(false);
  const [text, setText] = useState("");
  const dispatch = useDispatch();
  const {
    id: projectId,
    name: projectName,
    comment: projectComment,
    swot: projectSwot,
  } = useSelector((state) => state.project);
  const currentUser = useSelector((state) => state.currentUser);

  useEffect(() => {
    if (task) {
      setIsUpdateAction(true);
      setText(task.content);
    }
  }, [task]);

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    let data = {
      content: text,
      projectId: projectId,
      authorId: currentUser.id,
    };
    await dispatch(sendContribution(data));
    dispatch(loadProject(projectId));
    closeModal();
  };

  const handleSubmitUpdateAction = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    let data = {};
    if (task.content.trim() !== text) {
      data.content = text;
      await dispatch(updateContribution(task.id, data));
      dispatch(loadProject(projectId));
    }
    closeModal();
  };

  return (
    <FunctionalModal
      component={
        <Modal
          onSubmit={isUpdateAction ? handleSubmitUpdateAction : handleSubmit}
        >
          <div className={"flex-row w-100"}>
            <h1> {isUpdateAction ? "Modifier l'idée" : "Ajouter une idée"} </h1>
            <ExitButton closeUpdate={closeModal} />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Assistant
              context={{
                object: "idea",
                project: projectName,
                comment: projectComment,
                weakness: projectSwot
                  .filter((item) => item.type === "weakness")
                  .map((item) => item.content),
                threat: projectSwot
                  .filter((item) => item.type === "threat")
                  .map((item) => item.content),
              }}
              onSelect={(item) => {
                setText(item.description);
              }}
            />
          </div>
          <textarea
            value={text}
            maxLength="600"
            onChange={(e) => setText(e.target.value)}
            placeholder={"Écrivez votre idée ici (maximum 600 caractères)"}
          />
          <SendFormButton
            actionName={isUpdateAction ? "Modifier" : "Ajouter"}
            state={true}
          />
        </Modal>
      }
      setOpen={setIsOpen}
    />
  );
};

const Modal = styled(BaseModalForm)`
  height: 300px;
  margin: auto;
  align-items: center;
  padding: 1rem;

  h1 {
    flex-grow: 1;
    text-align: center;
  }

  .exit-btn {
    align-self: flex-start;
  }

  textarea {
    width: 80%;
    height: 60%;
  }

  @media (min-width: 700px) {
    width: 550px;
  }
`;
export default ContributionModal;
